import { resolveComponent as a, openBlock as n, createElementBlock as i, renderSlot as l, createElementVNode as o, createVNode as r, createCommentVNode as m } from "vue";
import { _ as f } from "./_plugin-vue_export-helper-dad06003.js";
import { P as u } from "./PencilFillIcon-1e21a80c.js";
import { A as k } from "./ArrowDownIcon-31fc6a85.js";
const $ = {
  name: "UtilsEdit",
  components: {
    PencilFillIcon: u
  },
  props: {
    enabled: {
      type: Boolean,
      default: !1
    }
  },
  emits: ["edit"]
}, w = {
  key: 0,
  class: "relative group/edit"
}, b = { class: "absolute -inset-1 border border-dashed opacity-0 group-hover/edit:opacity-100 border-sky-500 rounded-lg rounded-tr-none transition-opacity min-h-4" }, _ = { class: "h-4 w-4 bg-sky-500 rounded-r-sm flex items-center justify-center" };
function x(e, t, s, h, v, y) {
  const d = a("PencilFillIcon");
  return s.enabled ? (n(), i("div", w, [
    l(e.$slots, "default"),
    o("div", b, [
      o("div", {
        class: "absolute -top-[5px] -right-5 p-1 cursor-pointer",
        onClick: t[0] || (t[0] = (c) => e.$emit("edit"))
      }, [
        o("div", _, [
          r(d, { class: "w-2 h-2 text-white" })
        ])
      ])
    ])
  ])) : l(e.$slots, "default", { key: 1 });
}
const A = /* @__PURE__ */ f($, [["render", x]]), g = {
  name: "UtilsSection",
  components: {
    PencilFillIcon: u,
    ArrowDownIcon: k
  },
  props: {
    enabled: {
      type: Boolean,
      default: !1
    },
    hideMoveUp: {
      type: Boolean,
      default: !1
    },
    hideMoveDown: {
      type: Boolean,
      default: !1
    }
  },
  emits: ["edit", "move"]
}, I = {
  key: 0,
  class: "relative group/section"
}, B = { class: "absolute z-[1] top-0 inset-x-0 border-t-4 border-dotted opacity-0 group-hover/section:opacity-100 border-sky-500 transition-opacity h-6" }, C = { class: "absolute -top-[5px] -right-[5px] p-1 cursor-pointer flex space-x-px" };
function P(e, t, s, h, v, y) {
  const d = a("PencilFillIcon"), c = a("ArrowDownIcon");
  return s.enabled ? (n(), i("div", I, [
    o("div", B, [
      o("div", C, [
        o("div", {
          class: "flex-shrink-0 h-6 w-6 bg-sky-500 flex items-center justify-center",
          onClick: t[0] || (t[0] = (p) => e.$emit("edit"))
        }, [
          r(d, { class: "w-4 h-4 text-white" })
        ]),
        s.hideMoveDown ? m("", !0) : (n(), i("div", {
          key: 0,
          class: "flex-shrink-0 h-6 w-6 bg-sky-500 flex items-center justify-center",
          onClick: t[1] || (t[1] = (p) => e.$emit("move", 1))
        }, [
          r(c, { class: "w-5 h-5 text-white" })
        ])),
        s.hideMoveUp ? m("", !0) : (n(), i("div", {
          key: 1,
          class: "flex-shrink-0 h-6 w-6 bg-sky-500 flex items-center justify-center",
          onClick: t[2] || (t[2] = (p) => e.$emit("move", -1))
        }, [
          r(c, { class: "w-5 h-5 text-white transform rotate-180" })
        ]))
      ])
    ]),
    l(e.$slots, "default")
  ])) : l(e.$slots, "default", { key: 1 });
}
const E = /* @__PURE__ */ f(g, [["render", P]]);
export {
  A as UtilsEdit,
  E as UtilsSection
};
